//libs and utilities
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BREAKPOINT } from 'src/app-lang';
import { Link } from 'react-router-dom';
import { fetchNews } from './news-dux';
import { fetchUserLogin } from '../header/header-dux';

/*   Components
 *
 *   1. News
 *
 */

export class News extends React.Component {
	constructor(props) {
        super(props)
        this.itemRefs = {};
    }
    componentDidMount() {
		this.props.fetchNews();
		this.props.fetchUserLogin();
		window.scrollTo(0,0);
		
    }	
	componentWillReceiveProps( nextProps ) {
		let paramVal = this.props.location.param;
		if(this.props.page_Data.length > 0 && paramVal != undefined) {
			window.scrollBy({top: document.getElementById(paramVal).offsetTop + 130, behavior: 'smooth' });
		}
	}
    
    render() {
		let news = this.props.news;
		let content = news.pageData;
		const {location} = window;		
        let imageLocation = '';
        if(location.hostname === "localhost" && location.port == "3001") {
            imageLocation = "images/";
        } else {
            imageLocation = location.origin + '/wholesalechannelpartners/images/';
        }
        return(
			<section className={this.props.headerState != null ? "news " +this.props.headerState.paxAudienceType : "news default"}>
				{ content != undefined &&
					<div className="container">
						<div className="title"></div>
						{content.map((item,index) => {
							return <div id={item.promotionId} className="news-brief" key={index} ref={el => (this.itemRefs[item.promotionId] = el)}>
								<h3 dangerouslySetInnerHTML={{ __html: item.promoTextHdr }} />
								<div className="newslist">
									<img src={imageLocation+item.ralImage} />
									<div className="data" dangerouslySetInnerHTML={{ __html: item.promoTextBdy }} />
									<div className="clear"></div>
									<div className="hr-line"></div>
								</div>
							</div>
						})}
					</div>
				}
			</section>
        );
    }
}

export default connect(
    ( state ) => {
        return {
            news: state.news,
			headerState: state.headerState.audienceType,
			page_Data: state.news.page_Data
        };
    },
    ( dispatch ) => bindActionCreators( { fetchNews, fetchUserLogin }, dispatch )
)( News );



// WEBPACK FOOTER //
// ./src/news/news.jsx